import { useField } from 'formik';
import { useCallback } from 'react';

/**
 * A bit of a hack to disable a field programmatically via Formik
 */
export const useFieldLoadingOverlay = (fieldName: string) => {
  const [{ value: loadingOverlay }, , { setValue }] = useField<boolean | null>(`__loading-overlay-${fieldName}`);
  const setLoadingOverlay = useCallback((enabled: boolean) => setValue(enabled ? true : null), [setValue]);

  return { loadingOverlay, setLoadingOverlay };
};
